export default "__VITE_ASSET__CvYV49$B__"